import api from '../library/axios';

export default {
  getList(query) {
    return api({
      method: 'get',
      url: '/api/workspaces',
      params: query,
    });
  },
  getAllWorkspaces(query) {
    return api({
      method: 'get',
      url: '/api/backoffice/workspaces',
      params: query,
    });
  },
  getWorkspaces() {
    return api({
      method: 'get',
      url: '/api/backoffice/workspaces/pic',
    });
  },
  create({ name, ws_product_id }) {
    return api({
      method: 'post',
      url: '/api/workspaces',
      data: {
        name,
        ws_product_id,
      },
    });
  },
  update(id, data) {
    return api({
      method: 'put',
      url: `/api/backoffice/${id}/workspaces`,
      data,
    });
  },
  subscription(workspace_id, company_id, data) {
    return api({
      method: 'post',
      url: `/api/backoffice/${workspace_id}/${company_id}/workspaces/subscription`,
      data,
    });
  },
  approval(workspace_id, company_id, data) {
    return api({
      method: 'post',
      url: `/api/backoffice/${workspace_id}/${company_id}/workspaces/approval`,
      data,
    });
  },
  offboarding({ workspace_id, company_id, offboarded_date }) {
    return api({
      method: 'post',
      url: `/api/backoffice/${workspace_id}/${company_id}/workspaces/offboard`,
      data: {
        offboarded_date,
      },
    });
  },
  re_onboarding({ workspace_id, company_id }) {
    return api({
      method: 'post',
      url: `/api/backoffice/${workspace_id}/${company_id}/workspaces/re_onboarding`,
    });
  },
  pricing_plan(workspace_id, company_id) {
    return api({
      url: `/api/backoffice/${workspace_id}/${company_id}/workspaces/pricing_plan`,
    });
  },
  bot_questions({ id, company_id }) {
    return api({
      url: `/api/workspaces/${id}/${company_id}/questions`,
    });
  },
  update_bot_questions({ id, company_id, data }) {
    return api({
      method: 'patch',
      url: `/api/workspaces/${id}/${company_id}/questions`,
      data,
    });
  },
  work_hour({ id, company_id }) {
    return api({
      url: `/api/workspaces/${id}/${company_id}/work-hour`,
    });
  },
  update_work_hour({ id, company_id, data }) {
    return api({
      method: 'patch',
      url: `/api/workspaces/${id}/${company_id}/work-hour`,
      data,
    });
  },
  auto_reminder({ id, company_id }) {
    return api({
      url: `/api/workspaces/${id}/${company_id}/auto-reminder`,
    });
  },
  update_auto_reminder({ id, company_id, data }) {
    return api({
      method: 'patch',
      url: `/api/workspaces/${id}/${company_id}/auto-reminder`,
      data,
    });
  },
  check_balance({ id, company_id }) {
    return api({
      url: `/api/workspaces/${id}/${company_id}/balance`,
    });
  },
  updateCallFeature({ id, company_id, data }) {
    return api({
      method: 'put',
      url: `/api/backoffice/${id}/${company_id}/workspaces/call_feature`,
      data,
    });
  },
  connectAIDashboard({ id, company_id, packageId }) {
    return api({
      method: 'put',
      url: `/api/backoffice/${id}/${company_id}/workspaces/ai_dashboard`,
      data: {
        packageId,
      },
    });
  },
  getDeals(workspace_id, company_id) {
    return api({
      method: 'get',
      url: `/api/backoffice/${workspace_id}/${company_id}/workspaces/deals`,
    });
  },
  updateDeals({ id, company_id, data }) {
    return api({
      method: 'post',
      url: `/api/backoffice/${id}/${company_id}/workspaces/deals`,
      data: {
        data,
      },
    });
  },
  deleteDeals({ id, company_id, deals_id }) {
    return api({
      method: 'delete',
      url: `/api/backoffice/${id}/${company_id}/workspaces/deals/${deals_id}`,
    });
  },
  getBillings(workspace_id, company_id) {
    return api({
      method: 'get',
      url: `/api/backoffice/${workspace_id}/${company_id}/workspaces/billings`,
    });
  },
  updateCustomBot({ id, company_id, data }) {
    return api({
      method: 'post',
      url: `/api/backoffice/${id}/${company_id}/workspaces/custom_bot`,
      data,
    });
  },
};
